// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"7b58375c","703":"dfa05875","787":"3ba48579"}[chunkId] + ".chunk.js";
};